exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-results[data-v-5786b435] {\n  overflow-x: auto !important;\n  overflow-y: auto !important;\n}", ""]);

// exports
